import { useCookie } from 'next-cookie';
import { requests } from '@/helpers/api';
import { useMutation } from '@/hooks/useQuery';

const useRequestDemo = ({ lang }) => {
  const cookie = useCookie();
  const { mutate: setTimeslot, isError, isSuccess, isLoading, reset, data } = useMutation(requests.setTimeslot);

  const onSubmit = (values) => {
    if (!values.date_time?.utc?.utc || !values.date_time?.slot) return false;

    const roistatVisit = cookie.get('roistat_visit');
    const cookieUtm = cookie.get('utm');
    const utm = cookieUtm ? cookieUtm : {};
    const registerQuery = Object.entries(utm).map(([key, value]) => ({ key, value }));
    registerQuery.push({ key: 'curpage', value: window.location.origin + window.location.pathname });
    if (roistatVisit && !registerQuery.some(({ key }) => key === 'roistat_visit')) registerQuery.push({ key: 'roistat_visit', value: roistatVisit });

    const data = {
      timeslotId: values.date_time.slot,
      clientPhone: values.phone,
      clientEmail: values.email ?? 'demo@client.com',
      companyName: values.company_name,
      companySize: values.company_size,
      clientFullName: values.name ?? 'Не указано',
      gmt: values.date_time.utc.utc ?? '0',
      chanel: values.social ?? 'Звонок',
      registerQuery,
      roistatVisit
    };

    return setTimeslot(data, lang);
    // setSaveResult({ date: values.date_time.date, utc: values.date_time.utc.utc });
  };

  return {
    onSubmit,
    saveResult: data && { date: data.date_time.date, utc: data.date_time.utc.utc },
    isSuccess,
    isError,
    isLoading,
    reset
  };
};

export { useRequestDemo };
